(function () {

    'use strict';

    angular.module('app').controller('SettingsController', SettingsController);

    SettingsController.$inject = ['$rootScope', 'Currency', 'ClientService', 'toastr', 'Upload', '$q', '$timeout'];

    function SettingsController($rootScope, Currency, ClientService, toastr, Upload, $q, $timeout) {
        const vm = this;

        vm.removeLogo = removeLogo;
        vm.onChange = onChange;
        init();
        function init() {
            vm.unitOptions = [
                { weightUnit: 'kilograms', measureUnit: 'cm', label: 'KG / CM' },
                { weightUnit: 'pounds', measureUnit: 'in', label: 'LBS / IN' }
            ];

            vm.defaultUnit = vm.unitOptions.find(unit => unit.weightUnit === $rootScope.GlobalProfile.office.weightUnit) || vm.unitOptions[0];
            vm.isFetching = true;
            Currency.getList(function (data) {
                vm.currencyOptions = data;
                const defaultCurrency = $rootScope.GlobalProfile.office.currency || 'AUD';
                vm.defaultCurrency = data.find(currency => currency.currencyCode === defaultCurrency);
                vm.isFetching = false;
            });
            vm.taxConfiguration = $rootScope.GlobalProfile.office.tax;
            vm.enableUpdate = $rootScope.GlobalProfile.office.enableUpdate;

            getCompanyDetails();
            
        }

        function onChange(){
            if(vm.allBookingInsurance){
                vm.coverageInsurance = 'all_bookings'

                vm.allBookingInsurance = true
                vm.minimumInsurance = false;
                vm.optionalInsurance = false;
            }

            if(vm.minimumInsurance){
                vm.coverageInsurance = 'minimum_plus_extra'

                vm.minimumInsurance = true;
                vm.allBookingInsurance = false;
                vm.optionalInsurance = false;
            }

            if(vm.optionalInsurance){
                vm.coverageInsurance = 'optional';

                vm.optionalInsurance = true
                vm.allBookingInsurance = false;
                vm.minimumInsurance = false;
            }
        }

        function getCoverageinsurance(){
           
            if(vm.company.warrantyCoverageLevel ==='all_bookings'){
                vm.coverageInsurance = 'all_bookings'
                vm.allBookingInsurance = true
            }

            if(vm.company.warrantyCoverageLevel ==='minimum_plus_extra'){
                vm.coverageInsurance = 'minimum_plus_extra'
                vm.minimumInsurance = true;
            }

            if(vm.company.warrantyCoverageLevel ==='optional'){
                vm.coverageInsurance = 'optional'
                vm.optionalInsurance = true
            }

        }

        function getCompanyDetails() {
            ClientService.Company.get($rootScope.GlobalProfile.company.id, data => {
                vm.creditPayment = data.billingProfile.creditEnabled;
                vm.warrantyEnabled = data.warrantyEnabled;
                vm.coverageInsurance = data.warrantyCoverageLevel;
                vm.company = data

                vm.companyLogo = "";
                if (!vm.company.headerLogo) {
                    vm.logUrl = vm.company.logoUrl;
                } else {
                    vm.logUrl = "https://storage.googleapis.com/bba-img/" + vm.company.headerLogo;
                }

                vm.logoDimension = { width: 600, height: 600 };
                vm.hideInformation = angular.copy(vm.company.hideReceiverInfo);
                vm.hideInformationAdmin = angular.copy(vm.company.hideReceiverInfoAdmin);
                getCoverageinsurance();
            }, error => {
                toastr.error(error.error.message, 'Error');
            });
        }

        vm.save = function () {
            
            const office = angular.copy($rootScope.GlobalProfile.office);
            const company = angular.copy($rootScope.GlobalProfile.company);
            office.companyId = office.company.id;
            office.location = office.location.id;
            office.locationProfile.location = office.locationProfile.location.id;

            delete office.company;
            delete company.reseller;

            office.weightUnit = vm.defaultUnit.weightUnit;
            office.measureUnit = vm.defaultUnit.measureUnit;
            office.currency = vm.defaultCurrency.currencyCode;
            office.tax = vm.taxConfiguration;
            office.enableUpdate = vm.enableUpdate;

            company.warrantyEnabled = vm.warrantyEnabled
            company.warrantyCoverageLevel =  vm.coverageInsurance;
           
            company.location = company.location.id
            company.billingProfile.location = company.billingProfile.location.id
            company.billingProfile.creditEnabled = vm.creditPayment;
            company.paymentPreferences = vm.company.paymentPreferences;

            company.hideReceiverInfo = vm.hideInformation;
            company.hideReceiverInfoAdmin = vm.hideInformationAdmin;

            vm.saveInProgress = true;

            updateHideInformationStatusDashboard().then(data => {
                updateHideInformationStatusAdmin().then(data => {
                    ClientService.Location.update(office, function (response) {
                        $rootScope.GlobalProfile.office = response;
                        saveCompanyData(company);
                        upload(vm.companyLogo, company.id).finally(() => {
                        });
                        vm.saveInProgress = false;
                    }, function (error) {
                        toastr.error(error.message || 'Contact administrator if this error will occur again');
                        vm.saveInProgress = false;
                    }, office.id);
                });
            });
        }

        function saveCompanyData(data) {
            ClientService.Company.update(data, function (response) {
                $rootScope.GlobalProfile.company = response;
                toastr.success("Data successfully updated!");
            }, function (error) {
                toastr.error(error.message || 'Contact administrator if this error will occur again');
                vm.saveInProgress = false;
                return;
            }, data.id);
        }

        function upload(file, companyId) {
            const defer = $q.defer();
            if (!file) {
                $timeout(() => defer.reject({}));
            } else {
                Upload.resize(file, vm.logoDimension).then(resizedFile => {
                    ClientService.Company.uploadLogoEmail(resizedFile, companyId, vm.company.email, data => {
                        defer.resolve(data);
                    }, err => {
                        defer.reject(err);
                        toastr.error('Unable to save logo', 'Please try again later');
                    })
                });
            }
            return defer.promise;
        }

        function removeLogo() {
            ClientService.Company.removeLogo(vm.company.id, data => {
                init();
                vm.logUrl = vm.company.logoUrl;
                toastr.success("Data successfully updated!");
            }, err => {
                toastr.error('Unable to save logo', 'Please try again later');
            })

        }

        function updateHideInformationStatusDashboard() {
            const defer = $q.defer();
            ClientService.Company.hideDetails(vm.company.id, vm.hideInformation, function (response) {
                toastr.success('Customer information is now hidden in dashboard');
                defer.resolve(response);
            }, function (error) {
                toastr.error(error.error.message, 'Error');
                defer.reject(error);
            });
            return defer.promise;
        }

        function updateHideInformationStatusAdmin() {
            const defer = $q.defer();
            ClientService.Company.hideDetailsAdmin(vm.company.id, vm.hideInformationAdmin, function (response) {
                toastr.success('Customer information is now hidden in admin');
                defer.resolve(response);
            }, function (error) {
                toastr.error(error.error.message, 'Error');
                defer.reject(error);
            });
            return defer.promise;
        }
    }
})();



// WEBPACK FOOTER //
// ./js/controllers/SettingsController.js